import { MIN_REQUEST_GAP_MS } from '../constants/translationConfig';

export const sleep = (milliseconds) =>
    new Promise((resolve) => setTimeout(resolve, milliseconds));

/**
 * Runs tasks one at a time and keeps their start times at least `minGap` ms apart.
 * With a 1 second gap we can never exceed the backend's 60 requests per minute, no matter
 * how many screens ask for translations at once.
 */
let queue = Promise.resolve();
let lastStartedAt = 0;

export const scheduleRequest = (task, minGap = MIN_REQUEST_GAP_MS) => {
    const run = queue.then(async () => {
        const wait = lastStartedAt + minGap - Date.now();
        if (wait > 0) await sleep(wait);
        lastStartedAt = Date.now();
        return task();
    });
    // A failed task must not block the ones queued behind it.
    queue = run.catch(() => undefined);
    return run;
};
